import React from "react";
import styles from "./styles/OurStory.module.css";

export default function OurStory() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <span className={styles.eyebrow}>Alliance Automation Private Limited.</span>
        <h2 className={styles.heading}>Our Story</h2>
        <div className={styles.body}>
          <p>
            Alliance Automation is an Industrial Automation and Robotics specialists with more than 20 years of knowledge and experience in Automation, Robotics, Plastic Moulding and Special Purpose Machines. We are known for providing smart and cost effective factory automation solutions that are taking businesses to the next level.
          </p>
          <p>
            Established in 2001 as Alliance Automation, it became Alliance Automation Systems Pvt. Ltd. in 2006. Alliance Automation provides multiple solutions in automation, robotics and special purpose machines to customers in different industries including Automotive, Manufacturing, and more. Alliance Automation began as a representative and authorized channel partner of Mitsubishi Electric India to provide Programmable controllers, Simple application controllers, motion controllers and other types of controllers. Since then Alliance Automation has grown to not only providing Automation solutions but also build several types of automation systems including robotics, special purpose machines and other types of automated systems along with plastic moulding.
          </p>
          <p>
            Alliance Automation is a leader in industrial automation. Our team has an excellent understanding and experience in manufacturing processes combined with in-depth knowledge of control systems, software&rsquo;s and robotics. We provide simple solutions to complex manufacturing applications tailored to specific requirements.
          </p>
          <p>
            Our role as the Mitsubishi Electric FA&rsquo;s Preferred Channel Partner strengthens our position of leadership and adds new momentum to our impressive record of sustained growth.
          </p>
        </div>
        {/* <button type="button" className={styles.historyBtn}>
          OUR HISTORY <span aria-hidden="true">&rarr;</span>
        </button> */}
      </div>
    </section>
  );
}
